import { authHeader } from './auth-header';
import Cookie from 'js-cookie';
import { createApiError, parseJsonSafely } from './api-error';

// URI da API EasySaude
//let baseApiUrl = 'https://hl63y57qj3.execute-api.us-east-2.amazonaws.com/api/';
let baseApiUrl = process.env.VUE_APP_BASEURI + '/api/';

export const userService = {
    login,
    logout,
    register,
	resetpassword,
    getAll,
};

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ email, password })
    };
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeoutId = setTimeout(() => controller && controller.abort(), 15000);

    if (controller) {
        requestOptions.signal = controller.signal;
    }

    return fetch(baseApiUrl + 'login', requestOptions)
        .then(response => response.text().then(text => {
            const data = parseJsonSafely(text);

            if (!response.ok) {
                if (response.status === 401) {
                    // auto logout if 401 response returned from api
                    localStorage.removeItem('user');
                    Cookie.remove('_easyindustria_token');
                }

                throw createApiError({
                    response,
                    data,
                    fallback: 'Não foi possível realizar o login.'
                });
            }

            if (!data || typeof data !== 'object') {
                throw createApiError({
                    response,
                    data,
                    fallback: 'A API retornou uma resposta inválida.'
                });
            }

            return data;
        }))
        .catch(error => {
            if (error && error.response) {
                throw error;
            }

            const unavailableError = new Error(
                error && error.name === 'AbortError'
                    ? 'A API não respondeu no tempo esperado. Tente novamente.'
                    : 'Não foi possível conectar à API. Verifique sua conexão e tente novamente.'
            );
            unavailableError.name = error && error.name === 'AbortError'
                ? 'AbortError'
                : 'ApiUnavailableError';
            unavailableError.code = 'API_UNAVAILABLE';
            unavailableError.cause = error;
            throw unavailableError;
        })
        .finally(() => clearTimeout(timeoutId))
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                user.login = new Date();
                // Configure cookie para funcionar melhor com diferentes navegadores, incluindo Simple Browser
                Cookie.set('_easyindustria_token', user.token, { 
                    expires: 1, // 1 dia
                    secure: false, // permitir HTTP para desenvolvimento
                    sameSite: 'lax' // mais permissivo para webviews
                });
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
}

function logout() {
    // remove user and company from local storage to log user out
    localStorage.removeItem('user');
    Cookie.remove('_easyindustria_token');
    this.$router.push('/login');
}

function resetpassword(payload) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
    };

    return fetch(baseApiUrl + 'password/forgot-password', requestOptions)
        .then(response => response.text().then((text) => {
            const data = text ? (() => { try { return JSON.parse(text); } catch (_) { return {}; } })() : {};
            if (!response.ok) {
                const message = (data && data.message) || response.statusText || 'Erro ao solicitar redefinição de senha.';
                return Promise.reject(new Error(message));
            }
            return data;
        }));
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(user)
    };
    return fetch(baseApiUrl + 'user/register', requestOptions).then(handleResponse);
}

function getAll(Aid) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(baseApiUrl + 'empresa/usersbyempresa/' + Aid, requestOptions)
        .then(handleResponse)
        .then(users => {
            if (users) {
                // store users in local storage
                localStorage.setItem('users', JSON.stringify(users));
            }
            return users;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem('user');
                Cookie.remove('_easyindustria_token');
                this.logout();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
